const BASE_URL = "https://covid19.secuoyas.io/api/v1/es";

export const getCCAA = code => {
  return fetch(`${BASE_URL}/ccaa`)
    .then((response) => {
      return response.json();
    })
}